<template>
  <div class="sign" v-loading="loading">
    <div class="contract-type-show">
      <template v-for="(item,key) in contractType">
        <ContractCard :logo="require('@/assets/img/contract/'+key+'.png')" :key="key" :status="key" :content="item.content"
          :num="item.num"></ContractCard>
      </template>
    </div>
    <!--	中间 合同签发 展示 card          -->
    <card-box class="contract-show" title="签发文件">
      <el-button slot="tt_r" type="text" @click="video_sign=true">签署教学视频</el-button>
      <div class="issue-contract">
        <el-upload v-if="this.user.authenStatus ==1" class="upload-demo" drag :http-request="local_file" accept=".pdf"
          :data="{business:'private'}" action mulitiply :show-file-list="false" :before-upload="beforeAvatarUpload"
          multiple>
          <!--              <i class="el-icon-upload"></i>-->
          <el-button class="open-local-file">打开本地文件</el-button>
        </el-upload>
        <el-button v-else @click="Verification()" class="open-local-file">打开本地文件</el-button>

        <!--   新增合同说明   -->

        <div class="add-explain">
          <span>1、仅支持 .pdf 格式。 2、文件大小需&lt; 10MB。</span>
        </div>

      </div>
    </card-box>
    <el-dialog :close-on-click-modal="false" v-dialogDrag title="印章制作视频" :visible.sync="video_sign" width="617" height="466"
      center>
      <div style="text-align: center;width: auto;max-width: 100%">
        <video-qx style="text-align: center;width: auto;max-width: 100%;height: auto;max-height: 340px"></video-qx>
        <el-button class="account-butn" @click="video_sign=false">确认</el-button>
      </div>
    </el-dialog>
    <!--  下面 最近文件 展示 card        -->
    <card-box class="contract-recently" title="最近文件">
      <el-button slot="tt_r" type="text" @click="$router.push({ path: '/document/all' })">更多</el-button>
      <div class="recentlyContractList">
        <template v-for="(contract,item) in recentlyContractList">
          <div :key="contract.id" v-if="recentlyContractList.length>0 &&item<4">
            <RecentlyCard :contract="contract"></RecentlyCard>
          </div>
        </template>
        <div class="div_test" v-if="recentlyContractList.length == 0">
          <img src="@/assets/img/nullDate.png" style="width: 235px;height: 120px; margin-left: -67px;" />
          <p style="color:rgba(49,202,132,1);font-size: 18px;width: 100%;padding: 0;margin: 0">暂无数据</p>
        </div>
      </div>
    </card-box>
  </div>
</template>

<script>
    import ContractCard from "@/components/card/ContractCard.vue";
    import RecentlyCard from "@/components/card/RecentlyCard.vue";
    import videoQx from "@/views/video_qx.vue";

    export default {
        data() {
            return {
                contractType: {
                    wait_for_me: {
                        content: "点击进入等待我签署的文件页面",
                        num: 0
                    },
                    wait_for_other: {
                        content: "点击进入等待他人签署的文件页面",
                        num: 0
                    },
                    completed: {
                        content: "点击进入已完成签署的文件页面",
                        num: 0
                    },
                    drafts: {
                        content: "点击进入草稿箱的文件页面",
                        num: 0
                    }
                },
                dialogVisible: false,
                loading: false,
                video_sign: false,
                loading_one: false,
                recentlyContractList: [],
                user: this.$SIF.getLocalStorage("userInfo"),
                mesla: {}
            };
        },
        created() {
            this.getDoc();
            this.getMeals()
        },
        components: {
            ContractCard,
            RecentlyCard,
            videoQx,
        },
        methods: {
            // 获取是否有套餐
            getMeals() {
                this.$SIF.httpPost({
                    url: this.$SIF._serve.meal + "/centreBalanceController/getUserId",
                    succFun: res => {
                        this.mesla = res.data
                    },
                    failFun: res => {
                        this.$message({
                            message: res.msg,
                            type: 'warning'
                        });
                    }
                });
            },
            // 验证
            Verification() {
                if (this.user.authenStatus != 1) {
                    this.$confirm('账号还没有认证,请先去认证.', '提示', {
                        confirmButtonText: '去认证',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.$router.push({name: this.user.userType == 1 ? 'enterpriseAuthe' : 'personalAuthentication'})
                    });
                    return
                }
                if (!this.mesla) {
                    this.$confirm('套餐余额不足，请重新购买套餐', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.$router.push({name: 'buyMeal'})
                    });
                    return;
                }
            },
            beforeAvatarUpload: function (file) {
                var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
                const extension = testmsg === 'pdf'
                const extension2 = testmsg === 'PDF'
                if (!extension && !extension2) {
                    this.$message({
                        message: '请上传.pdf格式的文件',
                        type: 'warning'
                    });
                    this.loading = false
                    return false;
                }

                const isLt2M = file.size / 1024 / 1024 < 10;
                if (!isLt2M) {
                    this.$message({
                        message: '上传文件不能超过 10MB!',
                        type: "warning"
                    });
                    this.loading = false
                    return false;
                }

                return extension || extension2 && isLt2M
            },
            local_file(dt) {
                dt.data["business"] = "private";
                dt.data["project"] = "web-sign";
                var that = this;
                if (dt.file.name.length > 100) {
                    that.$message({
                        message: '文件名称过长.请限制在100个字符之内',
                        type: "warning"
                    });
                    return
                }
                that.loading = true
                that.$SIF.uploadFile({
                    params: dt,
                    succFun: function (res) {
                        that.dita_ty = res.data
                        if (res.code == 10000) {
                            that.$SIF.httpPost({
                                url: that.$SIF._serve.manage + "/function/pdf/check",
                                data: {
                                    strcontracturi: res.data.id
                                },
                                succFun: res => {
                                    if (res.code == 10000) {
                                        that.$SIF.setLocalStorage('contractId', 1)
                                        var test = that.dita_ty.originalFilename.slice(0, that.dita_ty.originalFilename.length - 4)
                                        // that.$router.push({ name: 'local_file', params: { test:escape(test),id:1,pdfFileSaveId:that.dita_ty.id} });
                                        that.$router.push({
                                            name: 'local_file',
                                            params: {test: test, id: 1, type:10, pdfFileSaveId: that.dita_ty.id}
                                        });
                                    } else {
                                        that.loading = false
                                        that.$SIF.delFile({
                                            params: {
                                                id: that.dita_ty.id
                                            }
                                        });
                                        that.$message({
                                            message: res.msg,
                                            type: "warning"
                                        });
                                    }
                                },
                                failFun: function (res) {
                                    that.loading = false
                                    that.$SIF.delFile({
                                        params: {
                                            id: that.dita_ty.id
                                        }
                                    });
                                    that.$message({
                                        message: res.msg,
                                        type: "warning"
                                    });
                                }
                            });
                        } else {
                            that.loading = false
                            that.$message({
                                message: res.msg,
                                type: "warning"
                            });
                        }
                    },
                    failFun: function (res) {
                        that.loading = false
                        if (res) {
                            that.$message({
                                message: res.msg + ",请稍后上传",
                                type: "warning"
                            });
                        }
                    }
                });
            },
            getDoc() {
                this.$SIF.httpPost({
                    url: this.$SIF._serve.manage + "/contract/query/about/me",
                    data: {},
                    succFun: res => {
                        var dt = res.data;

                        for (var i = 0; i < dt.length; i++) {
                            if (this.contractType[dt[i].contractStatus]) {
                                this.contractType[dt[i].contractStatus].num++;
                            }
                        }
                    }
                });
                this.$SIF.httpPost({
                    url: this.$SIF._serve.manage + "/contract/query/about/me",
                    data: {
                        contractStatus: "drafts"
                    },
                    succFun: res => {
                        var dt = res.data;
                        for (var i = 0; i < dt.length; i++) {
                            if (this.contractType[dt[i].contractStatus]) {
                                this.contractType[dt[i].contractStatus].num++;
                            }
                        }
                    }
                });
                this.loading = true
                this.$SIF.httpPost({
                    url: this.$SIF._serve.manage + "/query/recently-contract",
                    data: {},
                    succFun: res => {
                        this.recentlyContractList = res.data;
                        this.loading = false
                    },
                    failFun: res => {
                        this.loading = false
                    }
                });
            }
        }
    };
</script>

<style>
    .sign {
        width: 100%;
        min-width: 500px;
        /*三角箭头的颜色*/
        scrollbar-arrow-color: #0FC87D;
        /*滚动条滑块按钮的颜色*/
        scrollbar-face-color: #cdcdcd;
        /*滚动条整体颜色*/
        scrollbar-highlight-color: #0099dd;
        /*滚动条阴影*/
        scrollbar-shadow-color: #cdcdcd;
        /*滚动条轨道颜色*/
        scrollbar-track-color: #fff;
        /*滚动条3d亮色阴影边框的外观颜色——左边和上边的阴影色*/
        scrollbar-3dlight-color: #0099dd;
        /*滚动条3d暗色阴影边框的外观颜色——右边和下边的阴影色*/
        scrollbar-darkshadow-color: #0099dd;
        /*滚动条基准颜色*/
        scrollbar-base-color: #0099dd;
    }

    .sign .el-card__header {
        padding: 10px 20px;
    }

    .sign .el-card__body {
        padding: 10px 20px;
    }

    .sign {
        height: 100%;
        overflow: auto;
        /*三角箭头的颜色*/
        scrollbar-arrow-color: #0FC87D;
        /*滚动条滑块按钮的颜色*/
        scrollbar-face-color: #cdcdcd;
        /*滚动条整体颜色*/
        scrollbar-highlight-color: #0099dd;
        /*滚动条阴影*/
        scrollbar-shadow-color: #cdcdcd;
        /*滚动条轨道颜色*/
        scrollbar-track-color: #fff;
        /*滚动条3d亮色阴影边框的外观颜色——左边和上边的阴影色*/
        scrollbar-3dlight-color: #0099dd;
        /*滚动条3d暗色阴影边框的外观颜色——右边和下边的阴影色*/
        scrollbar-darkshadow-color: #0099dd;
        /*滚动条基准颜色*/
        scrollbar-base-color: #0099dd;
    }

    .sign::-webkit-scrollbar {
        width: 4px;
        /*height: 4px;*/
    }

    .sign::-webkit-scrollbar-thumb {
        border-radius: 10px;
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        background: rgba(0, 0, 0, 0.2);
    }

    .sign::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        border-radius: 0;
        background: rgba(0, 0, 0, 0.1);
    }

    /*
         * 合同类型展示
         */
    .sign .contract-type-show {
        margin-bottom: 10px;
        height: 90px;
        text-align: center;
        display: flex;
        justify-content: space-between;
    }

    /*
         * 合同签发
         */
    .sign .contract-show {
        width: 100%;
    }

    .sign .contract-show .learn-video {
        float: right;
        padding: 3px 0;
        color: rgba(39, 175, 113, 1);
    }

    .div_test {
        width: 100% !important;
        /* height: 50px; */
        font-size: 12px;
        text-align: center;
        color: rgba(153, 153, 153, 1);

    }

    /*
         * 打开本地文件按键
         */
    .issue-contract {
        text-align: center;
    }

    .sign .contract-show .issue-contract .open-local-file {
        width: 184px;
        background: rgba(49, 202, 132, 1);
        box-shadow: 0px 2px 1px 0px rgba(27, 149, 93, 1);
        border-radius: 18px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        line-height: 35px;
        margin: 40px auto;
        text-align: center;
        padding: 0;
    }

    .upload-demo .el-upload-dragger {
        border: none;
        height: auto;
    }

    /*
         * 新增说明
         */
    .sign .contract-show .add-explain {
        width: 505px;
        height: 60px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        line-height: 17px;
        margin: 0 auto;
        text-align: center;
    }

    /*
         * 最近合同
         */
    .contract-recently {
        margin-top: 10px;
    }

    .recentlyContractList {
        font-size: 0;
        width: 100%;
        /* margin: 0 1%; */
        padding: 20px 5px;
        min-height: 190px
    }

    .recentlyContractList > div {
        display: inline-block;
        width: 25%;
        padding: 0 5px;
        box-sizing: border-box;
    }
</style>